/**
 * Rivalry Pro+ isolated frontend session (iter87.78.iso).
 *
 * SEPARATE localStorage key from `pickem_admin_user` — a Pro+ session
 * MUST NOT bleed into the site-admin console. Cleared independently.
 */
const KEY = "rivalry_pro_session_v1";
// iter87.199.28 — Cross-mode "has been Pro+ on this device" marker.
// Set once `/api/pro/me` returns a real Pro+ status (regardless of
// whether the caller used the legacy JWT or a Clerk-signed session).
// The standard hamburger menu reads this so the Return-to-Pro+ row
// shows up for Clerk-authed Pro+ users too, not just legacy JWT ones.
const SEEN_KEY = "tcr_pro_seen_v1";

export function loadSession() {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function saveSession(session) {
    localStorage.setItem(KEY, JSON.stringify(session));
}

export function clearSession() {
    localStorage.removeItem(KEY);
    localStorage.removeItem(SEEN_KEY);
}

export function getToken() {
    return loadSession()?.token || null;
}

export function markProSeen() {
    try { localStorage.setItem(SEEN_KEY, "1"); } catch { /* storage disabled */ }
}

export function hasSeenPro() {
    // iter87.199.28 — Either the legacy session is live OR the marker
    // is present (Clerk-authed Pro+ users on this device).
    try {
        return !!localStorage.getItem(KEY) || localStorage.getItem(SEEN_KEY) === "1";
    } catch {
        return false;
    }
}
